import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _map from "lodash/map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createInfiniteQueryHook from '@segment/utils/createInfinityQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
var DEFAULT_LIMIT = 9;
var DEFAULT_OFFESET = 0;
var cachedUseCasesArraySize = 0;
export var getUseCasesArraySize = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!cachedUseCasesArraySize) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", cachedUseCasesArraySize);

          case 2:
            _context.next = 4;
            return client.get("/content/entries/useCase");

          case 4:
            data = _context.sent;
            cachedUseCasesArraySize = data.length;
            return _context.abrupt("return", cachedUseCasesArraySize);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUseCasesArraySize(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchUseCases = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var filters,
        pagination,
        searchParams,
        _pagination$offset,
        offset,
        _pagination$limit,
        limit,
        result,
        allResultsSize,
        pageResult,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            filters = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            pagination = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            searchParams = new URLSearchParams();

            _map(filters, function (value, key) {
              var filterParams = value.map(function (item) {
                return item.value;
              });
              searchParams.set("fields.".concat(key).concat(filterParams.length > 1 ? "[in]" : ""), filterParams.toString());
            });

            _pagination$offset = pagination.offset, offset = _pagination$offset === void 0 ? DEFAULT_OFFESET : _pagination$offset, _pagination$limit = pagination.limit, limit = _pagination$limit === void 0 ? DEFAULT_LIMIT : _pagination$limit;
            searchParams.set("limit", limit.toString());
            searchParams.set("offset", offset.toString());
            _context2.next = 9;
            return client.get("/content/entries/useCase?".concat(searchParams.toString()));

          case 9:
            result = _context2.sent;
            _context2.next = 12;
            return getUseCasesArraySize(client);

          case 12:
            allResultsSize = _context2.sent;
            pageResult = {
              total: allResultsSize,
              skip: offset,
              limit: limit,
              items: result
            };
            return _context2.abrupt("return", pageResult);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchUseCases(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var createFetchUseCasesQuery = function createFetchUseCasesQuery(client, filters) {
  return [["useCase", "fetchUseCasePages", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
      var _ref3$pageParam, pagination, useCases;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$pageParam = _ref3.pageParam, pagination = _ref3$pageParam === void 0 ? {} : _ref3$pageParam;
              _context3.next = 3;
              return fetchUseCases(client, filters, pagination);

            case 3:
              useCases = _context3.sent;
              return _context3.abrupt("return", _objectSpread(_objectSpread({}, useCases), {}, {
                items: useCases.items
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }()];
};
export var useUseCasesQuery = createInfiniteQueryHook(createFetchUseCasesQuery, useStaticSiteBackend, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var nextOffset = p.skip - p.limit;

    if (nextOffset < 0) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  },
  getNextPageParam: function getNextPageParam(p) {
    var nextOffset = p.skip + p.limit;

    if (p.total <= nextOffset) {
      return;
    }

    return {
      offset: nextOffset,
      limit: p.limit
    };
  }
});